import React from "react";
import logo from "./logo.png";
import "./style.css";

export default () => (
  <div className={"menu-logo"}>
    <img className={"logo-image"} src={logo} alt="logo.jpg" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Logo/index.js